import { IModalSlice } from "./modalSlice.interface";

export const ModalSliceInitialState: IModalSlice = {
  modals: {},
  isOpen: false,
};
